// extracted by mini-css-extract-plugin
export default {"status-container":"Status_status-container__gJjDX"};